<div class="custom-paragraphs">
  <div class="custom-paragraphs-heading">
    <h2>custom paragraphs</h2>
    <a (click)="closeCustomParagraph()">Close</a>
  </div>

  <div class="documents-block">
    <div class="block box-shadow">
      <div class="block-header">
        <div class="name-sort" [ngClass]="{ selected: customParagraphsSort === 'name' }"
          (click)="sortCustomParagraphs('name')">
          name
        </div>
        <div class="search">
          <input aria-label="" type="text" placeholder="search paragraphs..."
            (keyup)="filterCustomParagraphs($event.target.value)" />
          <img class="search-icon" [src]="constants.assetsPath + '/img/icons/search-grey.svg'" />
        </div>
      </div>
      <div class="block-content">
        <!-- <div
          class="paragraph"
          *ngFor="let paragraph of pagedCustomParagraphs"
          [ngbPopover]="customParagraphContent"
          placement="{{ tooltipPlacement }}"
          triggers="mouseenter:mouseleave"
          (click)="selectCustomParagraph(paragraph)"
          [ngClass]="{
            selected: paragraph.selected,
            disabled: !paragraph.selected && existParagraphselected()
          }"
          [attr.data-id]="'custom-paragraph-' + paragraph.id"
        >
          <div class="title">
            {{ paragraph.id }} {{ paragraph.name }}
            <span class="text-selected" *ngIf="paragraph.selected">selected</span>
          </div>
          <ng-template #customParagraphContent>
            <div [innerHTML]="paragraph.instructions | linkify"></div>
          </ng-template>
        </div>
        <div class="paragraph disabled" *ngIf="pagedCustomParagraphs.length === 0">
          <div class="title">Ooops, there are no custom paragraphs!</div>
        </div> -->
        <div
          class="paragraph"
          #paragraphTrigger
          #paragraphPopover="ngbPopover"
          *ngFor="let paragraph of pagedCustomParagraphs"
          [ngbPopover]="customParagraphContent"
          placement="{{ tooltipPlacement }}"
          popoverClass="instructions-popover"
          [popperOptions]="shrinkInstructionsPopoverGap"
          triggers="mouseenter:mouseleave"
          closeDelay="350"
          (shown)="onInstructionsPopoverShown(paragraphPopover, paragraphTrigger)"
          (hidden)="onInstructionsPopoverHidden(paragraphPopover)"
          (click)="selectCustomParagraph(paragraph)"
          [ngClass]="{
            selected: paragraph.selected,
            disabled: !paragraph.selected && existParagraphselected()
          }"
          [attr.data-id]="'custom-paragraph-' + paragraph.id"
        >
          <div class="title">
            {{ paragraph.id }} {{ paragraph.name }}
            <span class="text-selected" *ngIf="paragraph.selected">selected</span>
          </div>
          <ng-template #customParagraphContent>
            <div [innerHTML]="paragraph.instructions | linkify"></div>
          </ng-template>
        </div>
        <div class="paragraph disabled" *ngIf="pagedCustomParagraphs.length === 0">
          <div class="title">Ooops, there are no custom paragraphs!</div>
        </div>

      </div>
      <div class="block-footer">
        <div class="page-number" *ngFor="let pageIndex of pagesList"
          [ngClass]="{ selected: pageIndex === selectedPage }" (click)="changePage(pageIndex)">
          {{ pageIndex }}
        </div>
      </div>
    </div>
  </div>
</div>